import React, { Component } from 'react';

import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import Carousel from 'nuka-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';

import { SharingPopup } from 'C4';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/sell/itineraries': 'Itineraries',
};

export default class CarouselPdf extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlideIndex: 1,
      items: [],
    };

    this.handleAfterSlide = this.handleAfterSlide.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onEsc);
    window.scrollTo(0, 0);
    const array = [
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Romantic_Weekend_in_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Romance.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/5-Day_Family_Vacation_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/5_Day_Family_Vacation.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Girlfriend_Getaway_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Girlfriend_Getaway.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Houston_Wine_Trail_Itinerary.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Wine_Trail_Escape.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Guy\'s_Weekend_in_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/The_Guys_Weekend.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/History_Buff\'s_Guide_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/History_Buff.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Foodie\'s_Guide_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Foodie.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Western_Heritage_Guide_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Urban_Cowboy.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Art_Themed_Visit_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Artshound.jpg',
      },
      {
        url: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Architecture_Tour_Guide_to_Houston.pdf',
        thumbnail: 'https://travpro.yourworldapps.nl/apptool/app/256/salesCompanion/Architecture_Buff.jpg',
      },
    ];

    this.setState({ items: array });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  handleAfterSlide(newSlideIndex) {
    this.setState({ currentSlideIndex: newSlideIndex });
  }

  render() {
    const { items } = this.state;
    const itemList = [];

    items.forEach((video, id) => {
      const {
        thumbnail,
        url,
      } = video;

f

      const key = id;
      itemList.push((
        <div key={key}>
          <a
            href={url}
            data-fancybox={url}
            data-options={JSON.stringify(fancyOptions)}
            data-caption=""
          >
            <img src={thumbnail} width="400px" alt="" />
          </a>
        </div>
      ));

      return null;
    });

    return (
      <div className="carousel__Container-pdf">
        <div className="carousel__Background--overlay" />
        <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={props => <ul className="breadcrumb__List carousel">{props.children}</ul>}
          LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
        />
        <Carousel
          slideIndex={this.state.currentSlideIndex}
          afterSlide={this.handleAfterSlide}
          slidesToShow={3}
          easing="easeExpOut"
          edgeEasing="easeExpInOut"
          framePadding="50px"
          cellSpacing={40}
          cellAlign="center"
          width="1280px"
          height="500px"
          slideWidth="400px"
          slideHeight="400px"
          heightMode="first"
          initialSlideWidth={400}
          initialSlideHeight={400}
          frameOverflow="visible"
          renderCenterLeftControls={({ previousSlide }) => (
            <button onClick={previousSlide} >
              <FontAwesomeIcon icon={['fas', 'angle-left']} />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button onClick={nextSlide}>
              <FontAwesomeIcon icon={['fas', 'angle-right']} />
            </button>
          )}
        >
          {itemList}
        </Carousel>
      </div>
    );
  }
}
